import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class GetConfigurationVersionAndSectionsResData extends ApiGenericResponse {
    caosConfiguration;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        //Per rendere tutto più flessibile si è deciso di non tipizzare la configurazione di caos
        if (obj.ConfigurationContent) this.caosConfiguration = JSON.parse(obj.ConfigurationContent);
    }
}
